import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import React from 'react';

import { TXTCLI_TelephoneX } from './FormContentDESH.messages.json';

interface Props {
  informationTag: TranslationTag;
}

const FormContentDESH: React.FC<Props> = ({ informationTag }) => (
  <section>
    <Translation {...informationTag} />
    <p>
      <StarsLink
        href="https://www.suchthilfezentrum-sl.de/unsere-angebote/fachstelle-gluecksspielsucht"
        target="_blank"
        rel="noopener noreferrer"
      >
        Suchthilfezentrum Schleswig - Fachstelle Glücksspielsucht
      </StarsLink>
    </p>
    <p>
      <Translation tagName="span" {...TXTCLI_TelephoneX} /> 04621 / 4861-0
    </p>
    <p>
      <StarsLink
        href="http://www.stadtmission-kiel.de/Stadtmission_Kiel__AFB48D9A302543DCA6243F23360AF192.htm"
        target="_blank"
        rel="noopener noreferrer"
      >
        Stadtmission Kiel - Fachstelle pathologisches Glücksspiel
      </StarsLink>
    </p>
    <p>
      <Translation tagName="span" {...TXTCLI_TelephoneX} /> 0431 / 2 60 44 500
    </p>
    <p>
      <StarsLink href="https://www.ats-sh.de" target="_blank" rel="noopener noreferrer">
        Suchthilfeverbund Nordelbien ATS - Fachstelle Glücksspielsucht
      </StarsLink>
    </p>
    <p>
      <Translation tagName="span" {...TXTCLI_TelephoneX} /> 04191 / 3625
    </p>
  </section>
);

export default FormContentDESH;
